module.exports = __webpack_public_path__ + "static/img/logo-zxq.c5154e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-zxq.jpg
// module id = TH3y
// module chunks = 1